const lookupTypes = {
  GET_BANNERS_SUCCESS: "GET_BANNERS_SUCCESS",
  GET_BANNER_DETAILS_SUCCESS: "GET_BANNER_DETAILS_SUCCESS",
  GET_BANNERS_LOADING: "GET_BANNERS_LOADING",
};

export default lookupTypes;
